import { render } from "./ThreadMessages.vue?vue&type=template&id=48ada3c6"
import script from "./ThreadMessages.vue?vue&type=script&lang=js"
export * from "./ThreadMessages.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ThreadMessages.vue?vue&type=style&index=0&id=48ada3c6&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__